import { render } from "./CatalogTable.vue?vue&type=template&id=03d54c17&ts=true"
import script from "./CatalogTable.vue?vue&type=script&lang=ts"
export * from "./CatalogTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__